import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { authStorage } from '../../lib/auth-storage'
import { NotFoundPage } from '../../pages/NotFoundPage'

/** Unknown paths: guests → login; authenticated users → branded 404. */
export function CatchAllRoute() {
  const location = useLocation()
  const { session, isLoading } = useAuth()
  const token = authStorage.getToken()

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (isLoading && !session) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-parch-50 text-sm text-ink-600">
        Loading your session...
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <NotFoundPage />
}
